import React from 'react';
import JavascriptTypedArrays from './JavascriptTypedArrays.jsx';
import JavascriptTypedArraysMethods from './JavascriptTypedArraysMethods.jsx';
import JavascriptTypedArraysReference from './JavascriptTypedArraysReference.jsx';

export default function JsTypedArrays() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Typed Arrays</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/typed-arrays' className='underline'>JS Typed Arrays</a></li>
<li><a href='/javascript/typed-arrays/methods' className='underline'>JS Typed Methods</a></li>
<li><a href='/javascript/typed-arrays/reference' className='underline'>JS Typed Reference</a></li>
      </ul>
    </div>
  );
}
